export interface DeviceOperationLogItem {
  content: string
  operatorName: string
  gmtCreate: string
}

export function normalizeOperationLogs(response: any, fallback: DeviceOperationLogItem[] = []) {
  const list = response?.result?.list || response?.list || response?.data || []

  if (!Array.isArray(list) || !list.length) return fallback

  return list.map((item: any) => ({
    content: item?.content || '',
    operatorName: item?.operatorName || '',
    gmtCreate: item?.gmtCreate || ''
  }))
}
